import { Controller } from "@hotwired/stimulus";

// Choosing an action asks Craig to draft, and there is nothing to draft from until the
// criteria is written.
export default class extends Controller {
  toggle() {
    const disabled = this.element.value.trim().length === 0;

    this.selects.forEach((select) => {
      select.disabled = disabled;
      // Fomantic hides the select behind a generated wrapper, which takes its own class.
      select.parentElement.closest(".ui.dropdown")?.classList.toggle("disabled", disabled);
    });
  }

  // Every action of this condition, and only this one -- each has its own form.
  get selects() {
    return [...(this.element.closest("form")?.querySelectorAll("[data-criteria-gated]") || [])];
  }
}
